"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Throbber = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const DEFAULT_H = 24;
const DEFAULT_W = 56;
const Throbber = _ref => {
  let {
    width = DEFAULT_W,
    height = DEFAULT_H,
    color = "#fff",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    height: height,
    width: width,
    viewBox: "0 0 32 24",
    fill: "currentColor",
    stroke: "none"
  }, props), /*#__PURE__*/_react.default.createElement("circle", {
    fill: color,
    cx: "0",
    cy: "12",
    r: "5"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: "0.1"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    fill: color,
    cx: "16",
    cy: "12",
    r: "5"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: "0.2"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    fill: color,
    cx: "32",
    cy: "12",
    r: "5"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: "0.3"
  })));
};
exports.Throbber = Throbber;
Throbber.displayName = "Throbber";